(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["main-search"] && !Shopify.designMode) return;
  try {
    (function() {
  const terms = ['mushroom coffee', 'mushroom matcha', 'coffee syrup', 'matcha whisk'];

  // The search results page renders a second #search-input (snippets/search-form.liquid),
  // so match every one on the page. Each gets its own independent animation state.
  const inputs = document.querySelectorAll('#search-input');
  if (!inputs.length) return;

  const animations = Array.prototype.map.call(inputs, function(input) {
    const defaultPlaceholder = input.placeholder;
    let termIndex = 0;
    let charIndex = 0;
    let isDeleting = false;
    let timer = null;
    let active = false;

    function type() {
      const term = terms[termIndex];

      if (!isDeleting) {
        charIndex++;
        input.placeholder = term.substring(0, charIndex);
        if (charIndex === term.length) {
          isDeleting = true;
          timer = setTimeout(type, 1500);
          return;
        }
      } else {
        charIndex--;
        input.placeholder = term.substring(0, charIndex);
        if (charIndex === 0) {
          isDeleting = false;
          termIndex = (termIndex + 1) % terms.length;
          timer = setTimeout(type, 400);
          return;
        }
      }

      timer = setTimeout(type, isDeleting ? 50 : 100);
    }

    function start() {
      if (active) return;
      active = true;
      termIndex = 0;
      charIndex = 0;
      isDeleting = false;
      timer = setTimeout(type, 500);
    }

    function stop() {
      active = false;
      clearTimeout(timer);
      input.placeholder = defaultPlaceholder;
    }

    input.addEventListener('input', function() {
      if (input.value.trim() !== '') {
        stop();
      } else if (!active) {
        start();
      }
    });

    return { input: input, start: start, stop: stop };
  });

  window.addEventListener('theme:drawer:right:opened', function() {
    animations.forEach(function(animation) {
      if (animation.input.value.trim() === '') animation.start();
    });
  });

  window.addEventListener('theme:drawer:right:closed', function() {
    animations.forEach(function(animation) {
      animation.stop();
    });
  });
})();
  } catch(e) { console.error(e); }
})();

})();
